import React from 'react';
import { Text } from '../text';

export interface SelectEmptyGroupProps {
    message: string;
    id?: string;
}

// Low-emphasis empty state shown beneath a group header when that group has no items.
// role none: inside a menu or listbox only items and groups may be exposed; a group's description refers to it by id.
export const SelectEmptyGroup: React.FC<SelectEmptyGroupProps> = ({ message, id }) => (
    <div id={id} role="none" className="px-4 py-2">
        <Text variant="body-small" className="text-system-on-surface-variant">
            {message}
        </Text>
    </div>
);
